<template>
  <v-dialog v-model="dialog" max-width="1100" scrollable>
    <v-card>
      <v-toolbar>
        <v-btn icon :disabled="loading" @click="dialog = false" data-testid="clinic_page_bulk_archive_dialog_close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t("clinic_page.bulk_archive") }}</v-toolbar-title>
        <v-spacer />
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-data-table
          v-model="selected_candidates"
          :headers="headers"
          :items="candidates"
          item-key="invite_id"
          show-select
          :items-per-page="-1"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item.last_active="{ item }">
            <span v-if="item.last_active">{{ format_date(item.last_active) }}</span>
            <span v-else class="font-italic">{{ $t("clinic_page.no_activity") }}</span>
          </template>

          <template v-slot:item.pending_invite="{ item }">
            <v-chip v-if="item.pending_invite" small outlined color="orange">
              {{ pending_invite_text(item) }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="loading" @click="dialog = false">
          {{ $t("common.cancel") }}
        </v-btn>
        <v-btn
          color="error"
          :loading="loading"
          :disabled="selected_candidates.length === 0"
          @click="confirm"
          data-testid="clinic_page_bulk_archive_confirm"
        >
          {{ $t("clinic_page.bulk_archive_selected", { count: selected_candidates.length }) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    candidates: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selected_candidates: [],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    headers() {
      return [
        { text: this.$t("clinic_page.name"), value: "name" },
        { text: this.$t("common.email"), value: "email" },
        { text: this.$t("clinic_page.last_active"), value: "last_active" },
        { text: this.$t("clinic_page.pending_invite"), value: "pending_invite", sortable: false },
      ];
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.select_all_candidates();
      }
    },
    candidates() {
      if (this.value) {
        this.select_all_candidates();
      }
    },
  },
  methods: {
    select_all_candidates() {
      this.selected_candidates = this.candidates.slice();
    },
    confirm() {
      this.$emit("confirm", this.selected_candidates.map((candidate) => candidate.invite_id));
    },
    format_date(value) {
      let date = new Date(value);
      return date.toLocaleDateString(this.$i18n.lang(), {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    pending_invite_text(item) {
      if (!item.invited_on) {
        return this.$t("clinic_page.pending_invite");
      }
      return this.$t("clinic_page.pending_invite_invited_on", { date: this.format_date(item.invited_on) });
    },
  },
};
</script>
